import { SET_BULK_PARAMS_PERFORMER, CLEAR_PARAMS_PERFORMER, SET_PARAMS_PERFORMER } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_PERFORMER:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_PERFORMER:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_PERFORMER:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
